import {NotBlankGenericFieldValidator} from './not-blank-generic-field-validator'

export class RequiredRadioButtonFieldValidator extends NotBlankGenericFieldValidator {
  constructor() {
    super('requires a response')
  }
}
